import styled from 'styled-components';

const PaymentBlock = styled.div`
  text-align: center;
  width: 104.1%;
  margin-bottom: -1em;
  color: ${props => (props.isActive ? props.theme.color.text : props.theme.color.label)};
`;

const Rectangle = styled.div`
  width: calc(20% - 2px);
  margin-right: 3.5%;
  min-width: 109px;
  height: 119px;
  border-radius: 4px;
  border: 1px solid
    ${props =>
    props.isActive && !props.disabled ? props.theme.color.primary : props.theme.color.border};
  margin-bottom: 1.3em;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  ${props => !props.disabled && 'cursor: pointer;'};
  color: ${props => (props.isActive ? props.theme.color.text : props.theme.color.label)};
  &:first-child {
    img {
      width: 60px;
    }
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 74px;
  width: 100%;
`;

const Icon = styled.img`
  width: 50px;
  height: 50px;
  display: block;
`;

const InscriptionSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  height: calc(119px - 74px);
  white-space: ${p => (p.nowrap ? 'nowrap' : 'initial')};
  width: 100%;
  margin-top: -0.5em;
  p {
    margin: 0;
    text-align: center;
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
    padding: 0 0.3em;
    box-sizing: border-box;
  }
`;

const ActionsBlock = styled.div`
  display: inline-block;
  margin-top: 14px;
  position: absolute;
`;

export default {
  Rectangle,
  Icon,
  IconWrapper,
  InscriptionSection,
  PaymentBlock,
  ActionsBlock
};
